import { buildCmsUrl } from "../../utils/imageHelper";

import { getSrcSet, getSizes } from "../../utils/imageHelper";


/*eslint-disable */

declare const window: any;

interface ReservaVehiculosComponentProps {
  vehiculo: any;
  reserva: any;
}

const ReservaVehiculosComponent: React.FC<ReservaVehiculosComponentProps> = ({ vehiculo, reserva }) => {
  return (
    <div className="reserva-vehiculos-detail-component">
      <div className="vehiculo-reserva-vehiculos-detail-component">
        <img 
          src={buildCmsUrl(vehiculo.src)} 
          srcSet={getSrcSet(vehiculo.src || '')}
          sizes={getSizes('600px')}
          alt={`Imagen del vehículo ${vehiculo.nombre || "Hyundai"}`} 
        />

      </div>
      <div className="text-reserva-vehiculos-detail-component">
        <div className="title-text-reserva-vehiculos-detail-component">Reserva este modelo</div>
        <div className="subtitle-text-reserva-vehiculos-detail-component">Apártalo desde</div>
        <div className="precio-text-reserva-vehiculos-detail-component">$ 1.000.000 COP</div>
        <a href={reserva} target="_blank" className="btn-text-reserva-vehiculos-detail-component">Reservar en línea</a>
      </div>
    </div>
  );
};

export default ReservaVehiculosComponent;
